import gql from 'graphql-tag';

export default gql`
     mutation($lang: String!) {
         changeLang(lang: $lang){
            code
            result
         }
    }
`;